module.exports = __webpack_public_path__ + "static/Our-Story-bcc07ed08202d085cdbea8b21e6366c9.jpg";